import React from 'react';
import { useTranslations } from '../contexts/translation.context';

const Footer: React.FC<any> = ({ isPartner }) => {
  const { t, lang } = useTranslations();
  const currentLang = lang || 'en';

  return (
    <footer className="px-6 py-6 flex flex-wrap gap-2 md:gap-[1.875rem] text-sm text-neutral-800 font-regular leading-[1.125rem]">
      <span>
        © 2025 <span className={isPartner ? 'text-partner' : 'text-primary'}>OnlyU</span>
      </span>
      <a
        href={`https://onlyu.market/${currentLang}/privacy-policy`}
        target="_blank"
        rel="noopener noreferrer"
        className="font-normal hover:underline"
      >
        {t('footer.privacy')}
      </a>
      <a
        href={`https://onlyu.market/${currentLang}/terms-of-service`}
        target="_blank"
        rel="noopener noreferrer"
        className="font-normal hover:underline"
      >
        {t('footer.terms')}
      </a>
    </footer>
  );
};

export default Footer;
